import type { AppRouteRecordRaw, AppRouteModule } from '@/router/types';

import { PAGE_NOT_FOUND_ROUTE, REDIRECT_ROUTE, PAGE_OTHER_ROUTE } from '@/router/routes/basic';
// import { TiktokOrderNotice } from '@/router/routes/tiktokPlatformOrder';

import { mainOutRoutes } from './mainOut';
import { PageEnum } from '@/enums/pageEnum';

// import.meta.glob() 直接引入所有的模块 Vite 独有的功能
const modules = import.meta.glob('./modules/**/*.ts', { eager: true });
const routeModuleList: AppRouteModule[] = [];

// 加入到路由集合中
Object.keys(modules).forEach((key) => {
  const mod = (modules as Recordable)[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routeModuleList.push(...modList);
});

export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE, ...routeModuleList];
console.log(asyncRoutes, '=asyncRoutes=');

// 根路由
export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: PageEnum.BASE_HOME || '/goodsManage',
  meta: {
    title: 'Root',
  },
};

export const checkoutRoute = [
  {
    path: '/checkout/store',
    name: 'Checkout',
    component: () => import('@/views/checkout/store/index.vue'),
    meta: {
      title: '收银台',
      hideTab: true,
    },
  },
  {
    path: '/checkout/cashier',
    name: 'Cashier',
    component: () => import('@/views/checkout/store/cashier.vue'),
    meta: {
      title: '收银台',
      hideTab: true,
    },
  },
];

// Basic routing without permission
// 未经许可的基本路由
export const basicRoutes = [
  // LoginRoute,
  RootRoute,
  // ...checkoutRoute,
  ...mainOutRoutes,
  ...PAGE_OTHER_ROUTE,
  // TiktokOrderNotice,
  REDIRECT_ROUTE,
  PAGE_NOT_FOUND_ROUTE,
];
